import React, { useEffect, useState } from 'react';

const Accordion = (props) => {
    return(
        <>
        {props.children}
        </>
    )
} 

export default Accordion;